export enum UserActionTypeDeletion {
  MailMessagesDeleted = 'MailMessagesDeleted',
  MailFoldersDeleted = 'MailFoldersDeleted',
  ContactGroupsDeleted = 'ContactGroupsDeleted',
  ContactsDeleted = 'ContactsDeleted',
  CalendarGroupsDeleted = 'CalendarGroupsDeleted',
  CalendarsDeleted = 'CalendarsDeleted',
  CalendarEventsDeleted = 'CalendarEventsDeleted',
  DriveItemsDeleted = 'DriveItemsDeleted',
  SharePointItemsDeleted = 'SharePointItemsDeleted',
  TeamDrivesItemsDeleted = 'TeamDrivesItemsDeleted'
}
